var _excluded = ["listType", "space", "indent", "inset", "position", "start", "reversed", "children"],
  _excluded2 = ["listType", "space", "indent", "inset", "position", "children"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
import React from "react";
import { isValidSpacing, validUnorderedListTypeValues, spacingPropTypeMap, validListPositionValues, validOrderedListTypeValues } from "./utils";
import styled, { css } from "styled-components";
import { pl, mt, map } from "@nib/layout";
import Copy from "./Copy";
var spacingStyles = function spacingStyles(space) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), map(space, function (val) {
    return isValidSpacing(val) && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        > li:not(:first-child) {\n          ", ";\n        }\n      "])), mt(val));
  }));
};
var indentStyles = function indentStyles(indent) {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n"])), map(indent, function (val) {
    return isValidSpacing(val) && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        ", ";\n      "])), pl(val));
  }));
};
var insetStyles = function insetStyles(inset, position) {
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", "\n"])), map(inset, function (val) {
    return isValidSpacing(val) && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n        ", "\n      "])), position === "inside" ? css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n              > li:before {\n                content: '';\n                ", ";\n              }\n            "])), pl(val)) : css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n              > li {\n                ", ";\n              }\n            "])), pl(val)));
  }));
};
var BaseListStyles = function BaseListStyles(_ref) {
  var space = _ref.space,
    inset = _ref.inset,
    listType = _ref.listType,
    position = _ref.position,
    indent = _ref.indent;
  return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  list-style-type: ", ";\n  list-style-position: ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), listType, position, space && spacingStyles(space), inset && insetStyles(inset, position), indent && indentStyles(indent));
};
var StyledOrderedList = styled.ol(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref2) {
  var space = _ref2.space,
    inset = _ref2.inset,
    listType = _ref2.listType,
    position = _ref2.position,
    indent = _ref2.indent;
  return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    ", ";\n  "])), BaseListStyles({
    space: space,
    inset: inset,
    listType: listType,
    position: position,
    indent: indent
  }));
});
var StyledUnorderedList = styled.ul(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref3) {
  var space = _ref3.space,
    inset = _ref3.inset,
    listType = _ref3.listType,
    position = _ref3.position,
    indent = _ref3.indent;
  return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n    ", ";\n  "])), BaseListStyles({
    space: space,
    inset: inset,
    listType: listType,
    position: position,
    indent: indent
  }));
});
export var OrderedList = function OrderedList(props) {
  var _props$listType = props.listType,
    listType = _props$listType === void 0 ? "decimal" : _props$listType,
    _props$space = props.space,
    space = _props$space === void 0 ? 2 : _props$space,
    _props$indent = props.indent,
    indent = _props$indent === void 0 ? {
      xs: 4,
      md: 6
    } : _props$indent,
    _props$inset = props.inset,
    inset = _props$inset === void 0 ? {
      xs: 4,
      md: 6
    } : _props$inset,
    _props$position = props.position,
    position = _props$position === void 0 ? "outside" : _props$position,
    start = props.start,
    _props$reversed = props.reversed,
    reversed = _props$reversed === void 0 ? false : _props$reversed,
    children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(StyledOrderedList, _extends({
    "data-mesh-component": "ORDERED-LIST",
    indent: indent,
    listType: listType,
    inset: inset,
    position: position,
    space: space,
    start: start,
    reversed: reversed
  }, otherProps), children);
};
OrderedList.displayName = "OrderedList";
export var UnorderedList = function UnorderedList(props) {
  var _props$listType2 = props.listType,
    listType = _props$listType2 === void 0 ? "disc" : _props$listType2,
    _props$space2 = props.space,
    space = _props$space2 === void 0 ? 2 : _props$space2,
    _props$indent2 = props.indent,
    indent = _props$indent2 === void 0 ? {
      xs: 4,
      md: 6
    } : _props$indent2,
    _props$inset2 = props.inset,
    inset = _props$inset2 === void 0 ? {
      xs: 4,
      md: 6
    } : _props$inset2,
    _props$position2 = props.position,
    position = _props$position2 === void 0 ? "outside" : _props$position2,
    children = props.children,
    otherProps = _objectWithoutProperties(props, _excluded2);
  return /*#__PURE__*/React.createElement(StyledUnorderedList, _extends({
    "data-mesh-component": "UNORDERED-LIST",
    indent: indent,
    listType: listType,
    position: position,
    inset: inset,
    space: space
  }, otherProps), children);
};
UnorderedList.displayName = "UnorderedList";
export var ListItem = styled(Copy).attrs({
  component: "li"
})(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral([""])));
ListItem.displayName = "ListItem";